require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-paul-conrad-lecture-for-melbourne-design-week-3.json") })
        }
      }, "path---journal-paul-conrad-lecture-for-melbourne-design-week-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-paul-conrad-lecture-for-melbourne-design-week-3!./.cache/json/journal-paul-conrad-lecture-for-melbourne-design-week-3.json
// module id = 523
// module chunks = 231608221292675